<template>
    <th @click="setSort">
        <span class="column-order">
            <span>{{title}}</span>
            <i class="pg pg-chevron-up" v-bind:class="{active: this.$props.sort.value === this.$props.sortKey }"
               v-if="this.$props.sort.value === this.$props.sortKey && this.$props.sort.direction === 'asc'"/>
            <i class="pg pg-chevron-down" v-bind:class="{active: this.$props.sort.value === this.$props.sortKey }"
               v-else/>
        </span>
    </th>
</template>

<script>
  export default {
    name: 'SortItem',
    props: ['sort', 'title', 'sortKey'],
    methods: {
      setSort () {
        this.$emit('set-sort', this.$props.sortKey)
      }
    }
  }
</script>

<style lang="scss" scoped>

</style>